<template>
    <div class="printServiceAuthenticationBox">
        <div class="printBanner">
            <div class="printBannerContent">
                <h1>水泵云服务商</h1>
                <h3>——水泵云服务商入驻</h3>
            </div>
        </div>
        <div class="serviceAuthenticationContent">
            <ul class="articleSteps">
                <li v-for="item in stepsList" :key="item.id"
                    :class="currentStepId >= item.id?currentStepId === item.id?'active':'before':''">
                    <div :class="item.id === '5'?currentStepId === '5'?examineStatus === 'REJECT'?'examineError stepsContent':examineStatus === 'APPROVE'?'examineSuccess stepsContent':'stepsContent':'stepsContent':'stepsContent'">
                        <div class="num">{{item.num}}</div>
                        <div class="name">{{item.id === '5'?currentStepId === '5'?examineStatus === 'REJECT'?'审核未通过':examineStatus === 'APPROVE'?'审核通过':'等待审核':'等待审核':item.name}}</div>
                    </div>
                    <div class="line" v-if="item.id !== '5'"></div>
                </li>
            </ul>
            <div class="comment">
                <!--入住须知-->
                <div class="commentItem" v-show="currentStepId === '0'">
                    <div class="commentItemContent" style="padding: 20px 0">
                        <el-scrollbar style="height: 500px">
                            <div style="padding: 0 30px 30px">
                                <h3>{{ contentTitle }}</h3>
                                <div v-html="content" class="vHtmlMess"></div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div class="commentItemButtonGroup">
                        <el-button class="conventionButton" @click="currentStepId = '1'">开始申请</el-button>
                    </div>
                </div>
                <!--公司联系人-->
                <div class="commentItem" v-show="currentStepId === '1'">
                    <div class="commentItemContent">
                        <div class="explain">
                            <i class="el-icon-warning-outline"></i>说明：用于入驻过程中接收平台反馈通知、联络，请务必填写正确
                        </div>
                        <el-form :model="contactsForm" :rules="contactsRules" ref="contactsFormRef" label-width="120px"
                                 class="contactsFormClass">
                            <el-form-item label="联系人姓名:" prop="contact">
                                <el-input v-model="contactsForm.contact" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人电话:" prop="contactTel">
                                <el-input v-model="contactsForm.contactTel" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="联系人邮箱:" prop="contactMail">
                                <el-input v-model="contactsForm.contactMail" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="commentItemButtonGroup">
                        <el-button class="conventionButton" @click="submitContactsForm">下一步</el-button>
                    </div>
                </div>
                <!--开户行-->
                <div class="commentItem" v-show="currentStepId === '2'">
                    <div class="commentItemContent">
                        <div class="explain">
                            <i class="el-icon-warning-outline"></i>说明：用于店铺结算，请务必填写正确
                        </div>
                        <el-form :model="contactsForm" :rules="openingBankRules" ref="openingBankFormRef"
                                 label-width="150px" class="contactsFormClass">
                            <el-form-item label="银行名称:" prop="bankName">
                                <el-input v-model="contactsForm.bankName" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户银行支行:" prop="bankSubbranch">
                                <el-input v-model="contactsForm.bankSubbranch" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户名:" prop="bankType">
                                <el-input v-model="contactsForm.bankType" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="银行账号:" prop="bankAccount">
                                <el-input v-model="contactsForm.bankAccount" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户支行联行号:">
                                <el-input v-model="contactsForm.accountBankSubbranch" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="commentItemButtonGroup">
                        <el-button class="backButton" @click="currentStepId = '1'">返回上一级</el-button>
                        <el-button class="conventionButton" @click="submitOpeningBankForm">下一步</el-button>
                    </div>
                </div>
                <div class="commentItem" v-show="currentStepId === '3'">
                  <div class="commentItemContent">
                    <el-form :model="contactsForm" :rules="storeInformationRules" ref="storeInformationFormRef"
                             label-width="150px" class="storeInformationFormClass">
                      <div class="title">·基本信息</div>
                      <el-form-item label="主页名称" prop="name">
                        <el-input v-model="contactsForm.name" disabled placeholder="请输入"></el-input>
                      </el-form-item>
                      <el-row class="addressSelect">
                        <el-col :span="12">
                          <el-form-item label="地址" prop="storeCity">
                            <el-cascader
                                v-model="contactsForm.storeCity"
                                :options="regionOptions"
                                placeholder="省/市/区"
                                style="width: 334px"
                            ></el-cascader>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item prop="address" class="storeAddress">
                            <el-input v-model="contactsForm.address" placeholder="请输入"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                  <div class="commentItemButtonGroup">
                    <el-button class="backButton" @click="currentStepId = '2'">返回上一级</el-button>
                    <el-button class="conventionButton" @click="submitStoreInformationForm">下一步</el-button>
                  </div>
                </div>
                <!--在线协议-->
                <div class="commentItem" v-show="currentStepId === '4'" v-loading="loading">
                    <div class="commentItemContent" style="padding: 20px 0">
                        <el-scrollbar style="height: 500px">
                            <div style="padding: 0 30px 30px">
                                <h3>{{ contentTitle }}</h3>
                                <div v-html="content" class="vHtmlMess"></div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <el-checkbox style="padding-top: 15px;" v-model="checkedAgree" :disabled="countDownNum > 0">
                        我已仔细阅读，并同意协议
                    </el-checkbox>
                    <span style="padding-left: 10px;" v-show="countDownNum > 0"><span style="color:#009999">{{countDownNum}}</span> s</span>
                    <div class="commentItemButtonGroup">
                        <el-button class="backButton" @click="currentStepId = '3',checkedAgree = false,countDownNum = 5">返回上一级</el-button>
                        <el-button class="conventionButton" @click="submitApply">提交入驻申请</el-button>
                    </div>
                </div>
                <!--等待审核-->
                <div class="commentItem" v-show="currentStepId === '5'">
                    <div class="commentItemContent">
                        <div style="padding-bottom: 40px;" v-show="examineStatus === 'APPROVE'">

                        </div>
                        <div class="explain" style="margin-bottom: 40px;" v-show="examineStatus !== 'APPROVE'">
                            <i class="el-icon-warning-outline"></i>
                            <span v-show="examineStatus === 'REJECT'">驳回原因：{{contactsForm.remark}}</span>
                            <span v-show="examineStatus !== 'APPROVE' && examineStatus !== 'REJECT'">说明：平台将于7个工作日内审核反馈，请您注意查看系统信息。</span>
                        </div>
                        <div class="table">
                            <ul class="header">
                                <li>步骤</li>
                                <li>状态</li>
                            </ul>
                            <div class="tableBody">
                                <ul class="tableItem">
                                    <li>填写入驻信息</li>
                                    <li><i class="el-icon-success"></i>已完成</li>
                                </ul>
                                <ul class="tableItem">
                                    <li>提交入驻申请</li>
                                    <li><i class="el-icon-success"></i>已完成</li>
                                </ul>
                                <ul class="tableItem">
                                    <li>商家信息认证</li>
                                    <li v-if="examineStatus === 'SUBMIT'"><i class="el-icon-warning"></i>审核中</li>
                                    <li v-if="examineStatus === 'APPROVE'"><i class="el-icon-success"></i>已完成</li>
                                    <li v-if="examineStatus === 'REJECT'"><i class="el-icon-error"></i>审核未通过</li>
                                </ul>
                                <ul class="tableItem" v-if="examineStatus === 'APPROVE'">
                                    <li>开户申请</li>
                                    <li v-if="applicationStatus === ''"><i class="el-icon-info"></i>未开户</li>
                                    <li v-if="applicationStatus === 'REVIEW_BACK'"><i class="el-icon-error"></i>开户失败</li>
                                    <li v-if="applicationStatus === 'COMPLETED'"><i class="el-icon-success"></i>已开户</li>
                                    <li v-if="applicationStatus !== ''
                                    &&applicationStatus !== 'COMPLETED'&&applicationStatus !== 'REVIEW_BACK'"><i class="el-icon-warning"></i>开户中</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="commentItemButtonGroup">
                        <!--<el-button class="conventionButton" @click="openNewAddress" v-if="examineStatus === 'APPROVE'">维护打印材料</el-button>-->
                        <el-button class="conventionButton" v-if="examineStatus === 'APPROVE'" @click="openAddress('accountManagement')">开户申请</el-button>
                        <el-button class="conventionButton" v-if="examineStatus === 'APPROVE'" @click="openAddress('serviceCapabilityMage')">服务能力维护</el-button>
                        <el-button class="conventionButton" @click="currentStepId = '0'" v-if="examineStatus === 'REJECT'">重新提交</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getNewcurrent,
    getEnterpriseCredentials,
  getInfoByWordNo,merchantCurrent
} from "@/utils/interface";
import { current,getSellerSettledInfo,saveSellerSettled } from '@/utils/shopStore';
import provinceData from "@/utils/provinceData";
import {getShopSettledInfo} from "../../../utils/shopStore";
export default {
    name: "printServiceAuthentication",
    components: {provinceData},
    data() {
        return {
            loading: false,
            currentStepId: '0',
            stepsList: [
                {
                    id: '0',
                    num: '1',
                    name: '入驻须知'
                },
                {
                    id: '1',
                    num: '2',
                    name: '公司联系人'
                },
                {
                    id: '2',
                    num: '3',
                    name: '开户行'
                },
                {
                  id: '3',
                  num: '4',
                  name: '主页信息'
                },
                {
                    id: '4',
                    num: '5',
                    name: '在线协议'
                },
                {
                    id: '5',
                    num: '6',
                    name: '等待审核'
                }
            ],
            contactsForm: {
                contact: '',
                contactTel: '',
                contactMail: '',
                bankName: '',
                bankSubbranch: '',
                bankType: '',
                bankAccount: '',
                accountBankSubbranch: '',
                name: '',
                storeCity: [],
                address: '',
                isAgree: 0,
                status: 'SUBMIT',
                province:'',
                city:'',
                district:'',
            },
            contactsRules: {
                contact: [
                    {required: true, message: '请输入联系人名称', trigger: 'blur'}
                ],
                contactTel: [
                    {required: true, validator: this.validatorPhone, trigger: 'blur'}
                ],
                contactMail: [
                    {required: true, validator: this.validatorEmail, trigger: 'blur'}
                ]
            },
            openingBankRules: {
                bankName: [
                    {required: true, message: '请输入银行名称', trigger: 'blur'}
                ],
                bankSubbranch: [
                    {required: true, message: '请输入开户银行支行', trigger: 'blur'}
                ],
                bankType: [
                    {required: true, message: '请输入开户名', trigger: 'blur'}
                ],
                bankAccount: [
                    {required: true, trigger: 'blur', validator: this.validatorBackNo }
                ]
            },
            storeInformationRules: {
                name: [
                    {required: true, message: '请输入主页名称', trigger: 'blur'}
                ],
                storeCity: [
                    {required: true, message: '请选择地址', trigger: 'expand-change'}
                ],
                address: [
                    {required: true, message: '请输入详细地址', trigger: 'blur'}
                ],
            },
            regionOptions: provinceData,
            checkedAgree: false,
            countDownNum: 5,
            examineStatus: '',
            content:"",
            contentTitle:"",
            applicationStatus:"",
        }
    },
    created() {

        merchantCurrent().then((res)=>{
            if(res.success){
                this.applicationStatus = res.data.applicationStatus;
            }else {
                this.applicationStatus = "";
            }
        });
		let newToken = this.$cookies.get("api_token_new");
		if(newToken){
        getInfoByWordNo({"wordNo":"SERVICE_ENTER_NOTICE"}).then((res)=>{
            if(res&&res.data){
                this.content = res.data.content;
                this.contentTitle = res.data.title;
            }
        });
        this.getSellerInfo();
        this.isServiceAuthentication();
		}else{
			this.$router.push('/supplyHome')
		}
    },
    methods: {
        openAddress(type){
            this.$cookies.set("authoritiesMess", "sellerCenterService");
            window.open(this.$url.sellerWeb+`#/${type}`,'_target');
        },
        openNewAddress(){
            window.open(this.$url.sellerWeb,'_target');
        },
        // 电话号码校验
        validatorPhone(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入联系人电话'))
            } else if (!/^1\d{10}$/.test(value)) {
                callback(new Error('请输入正确的电话号码'))
            } else {
                callback()
            }
        },
        validatorBackNo(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入银行卡号'))
            } /*else if(value.length < 16 || value.length > 19) {
                    callback(new Error('银行卡号长度必须在16到19之间'));
            }*/ else if(!this.validate.isDigits(value)) {
                callback(new Error('银行卡号必须全为数字'));
            } /*else if(!this.validate.isBankSecondNumber(value)) {
                callback(new Error('银行卡号开头6位不符合规范'));
            }*/ /*else if (!this.validate.isBankNo(value)) {
                callback(new Error('请输入正确的银行卡号'));
            }*/ else {
                callback();
            }
        },
        validatorEmail(rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入联系人邮箱'))
            } else if (!this.validate.isEmail(value)) {
                callback(new Error('请输入正确的邮箱地址'))
            } else {
                callback()
            }
        },
        // 公司联系人表单提交
        submitContactsForm() {
            this.$refs.contactsFormRef.validate((valid) => {
                if (valid) {
                    this.currentStepId = '2'
                } else {
                    return false;
                }
            });
        },
        // 开户行表单提交
        submitOpeningBankForm() {
            this.$refs.openingBankFormRef.validate((valid) => {
                if (valid) {
                    this.currentStepId = '3'
                } else {
                    return false;
                }
            });
        },
        // 店铺信息表单提交
        submitStoreInformationForm() {
            this.$refs.storeInformationFormRef.validate((valid) => {
                if (valid) {
                    this.currentStepId = '4';
					          this.checkedAgree =false;
                    this.countDown()
                } else {
                    return false;
                }
            });
        },
        // 提交入住申请
        submitApply() {
            if (this.checkedAgree) {
                this.loading = true;
                if(this.contactsForm.storeCity.length==2){
                    this.contactsForm.province = this.contactsForm.storeCity[0];
                    this.contactsForm.city = this.contactsForm.storeCity[1];
                }
                if(this.contactsForm.storeCity.length==3){
                    this.contactsForm.province = this.contactsForm.storeCity[0];
                    this.contactsForm.city = this.contactsForm.storeCity[1];
                    this.contactsForm.district = this.contactsForm.storeCity[2];
                }
                saveSellerSettled(this.contactsForm).then(result => {
                    this.isServiceAuthentication();
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                });
            } else {
                this.$message({
                    message: '请阅读并同意入驻协议！',
                    type: 'warning'
                })
            }
        },
        countDown() {
            if (this.currentStepId === '4') {
                this.countDownNum = 5;
                this.timer = setInterval(() => {
                    this.countDownNum--;
                    if (this.countDownNum === 0) {
                        clearInterval(this.timer)
                    }
                }, 1000)
            }
        },
        getSellerInfo() {
            // 判断用户是否已经入驻服务商了，如果入驻则获取服务商信息。
            // 如果没有入驻则获取用户本身参数信息
            current().then((res)=>{
                if(res&&res.success){
                    this.contactsForm.contactTel = res.data.contactTel;
                    this.contactsForm.contactMail = res.data.contactMail;
                    this.contactsForm.contact = res.data.contact;

                    if(res.data.province){
                        this.contactsForm.storeCity = [res.data.province]
                    }
                    if(res.data.city){
                        this.contactsForm.storeCity = [res.data.province,res.data.city]
                    }
                    if(res.data.district){
                        this.contactsForm.storeCity = [res.data.province,res.data.city,res.data.district]
                    }
                    // 地址
                    this.contactsForm.address = res.data.address;
                    // 银行信息
                    this.contactsForm.bankName = res.data.bankName;
                    this.contactsForm.bankSubbranch = res.data.bankSubbranch;
                    this.contactsForm.bankType = res.data.bankType;
                    this.contactsForm.bankAccount = res.data.bankAccount;
                    this.contactsForm.accountBankSubbranch = res.data.accountBankSubbranch;
                    this.contactsForm.name = res.data.name;
                }else{
                    // 获取当前用户信息
                    getNewcurrent().then((data) => {
                        getEnterpriseCredentials({userUuid:data.uuid}).then((res)=>{
                            if(res.success){
                                this.contactsForm.contactTel = res.data.contactTel;
                                this.contactsForm.contactMail = res.data.contactMail;
                                this.contactsForm.contact = res.data.contact;
                                this.contactsForm.name = res.data.name
                                if(res.data.province){
                                  this.contactsForm.storeCity = [res.data.province]
                                }
                                if(res.data.city){
                                  this.contactsForm.storeCity = [res.data.province,res.data.city]
                                }
                                if(res.data.district){
                                  this.contactsForm.storeCity = [res.data.province,res.data.city,res.data.district]
                                }
                              this.contactsForm.address = res.data.address;
                            }
                        });
                    })
                }
            });
        },
        // 判断是否认证成功
        isServiceAuthentication() {
          getSellerSettledInfo().then(res=>{
                if(res&&res.data!=null) {
                    this.examineStatus = res.data ? res.data.status : '';
                    if (res.data && res.data.status === 'APPROVE') {
                        this.currentStepId = '5';
                    } else if (res.data && res.data.status === 'SUBMIT') {
                        this.currentStepId = '5';
                    } else if (res.data && res.data.status === 'REJECT') {
                        this.currentStepId = '5';
                    } else {
                        this.currentStepId = '0';
                    }
                  this.contactsForm.contactTel = res.data.contactTel;
                  this.contactsForm.contactMail = res.data.contactMail;
                  this.contactsForm.contact = res.data.contact;
                  this.contactsForm.remark = res.data.remark;

                  if(res.data.province){
                    this.contactsForm.storeCity = [res.data.province]
                  }
                  if(res.data.city){
                    this.contactsForm.storeCity = [res.data.province,res.data.city]
                  }
                  if(res.data.district){
                    this.contactsForm.storeCity = [res.data.province,res.data.city,res.data.district]
                  }
                  // 地址
                  this.contactsForm.address = res.data.address;
                  // 银行信息
                  this.contactsForm.bankName = res.data.bankName;
                  this.contactsForm.bankSubbranch = res.data.bankSubbranch;
                  this.contactsForm.bankType = res.data.bankType;
                  this.contactsForm.bankAccount = res.data.bankAccount;
                  this.contactsForm.accountBankSubbranch = res.data.accountBankSubbranch;
                  this.contactsForm.name = res.data.name;
                }else {
                  //如果卖家没有，查商城是否认证
                  getShopSettledInfo().then(resp=>{
                    if(resp&&resp.data!=null) {
                      this.currentStepId = '0';
                      this.contactsForm.uuid=null;
                      this.contactsForm.contactTel = resp.data.contactTel;
                      this.contactsForm.contactMail = resp.data.contactMail;
                      this.contactsForm.contact = resp.data.contact;
                      this.contactsForm.remark = res.data.remark;

                      if(resp.data.province){
                        this.contactsForm.storeCity = [resp.data.province]
                      }
                      if(resp.data.city){
                        this.contactsForm.storeCity = [resp.data.province,resp.data.city]
                      }
                      if(resp.data.district){
                        this.contactsForm.storeCity = [resp.data.province,resp.data.city,resp.data.district]
                      }
                      // 地址
                      this.contactsForm.address = resp.data.address;
                      // 银行信息
                      this.contactsForm.bankName = resp.data.bankName;
                      this.contactsForm.bankSubbranch = resp.data.bankSubbranch;
                      this.contactsForm.bankType = resp.data.bankType;
                      this.contactsForm.bankAccount = resp.data.bankAccount;
                      this.contactsForm.accountBankSubbranch = resp.data.accountBankSubbranch;
                      this.contactsForm.name = resp.data.name;
                    }
                  })
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
    .printServiceAuthenticationBox {
        background: rgb(244, 244, 244);

        .printBanner {
            width: 100%;
            height: 448px;
            background: url("../../../assets/background/shop_settled.png") no-repeat left center;
            background-size: 100% 100%;
            color: #fff;

            .printBannerContent {
                width: 1200px;
                margin: 0 auto;
                padding-top: 130px;

                h1 {
                    font-weight: 700;
                    font-style: normal;
                    font-size: 30px;
                    padding-bottom: 30px;
                }

                h3 {
                    font-weight: 700;
                    font-style: normal;
                    font-size: 25px;
                }
            }
        }

        .serviceAuthenticationContent {
            width: 1200px;
            margin: 0 auto;
            background: #fff;
            border-radius: 10px;
            position: relative;
            top: -90px;
            box-sizing: border-box;
            padding: 30px 50px;

            .articleSteps {
                display: flex;
                justify-content: space-around;
                text-align: center;

                li {
                    font-weight: 400;
                    display: flex;
                    align-items: center;

                    .line {
                        height: 1px;
                        width: 98px;
                        background: #c0c0c0;
                        position: relative;
                        top: -14px;
                        left: 26px;
                    }

                    .num {
                        margin: 0 auto 15px;
                        width: 34px;
                        height: 34px;
                        border-radius: 50%;
                        text-align: center;
                        line-height: 34px;
                        border: 1px solid #dddddd;
                        color: #c0c0c0;
                        font-size: 13px;
                    }

                    .name {
                        color: rgba(0, 0, 0, 0.447058823529412);
                        font-size: 15px;
                    }

                    &:hover {
                        color: #009999;
                    }

                    &.active {
                        font-weight: 700;

                        .num {
                            color: #fff;
                            background: #009999;
                            border: 1px solid #009999;
                        }

                        .name {
                            color: #009999;
                        }
                    }
                    .examineError{
                        .num {
                            color: #fff;
                            background: #ff0000;
                            border: 1px solid #ff0000;
                        }

                        .name {
                            color: #ff0000;
                        }
                    }
                    .examineSuccess{
                        .num {
                            color: #fff;
                            background: #009900;
                            border: 1px solid #009900;
                        }

                        .name {
                            color: #009900;
                        }
                    }
                    &.before {
                        .num {
                            color: #009999;
                            border: 1px solid #009999;
                            background: #fff;
                        }

                        .name {
                            color: #009999;
                        }

                        .line {
                            background: #009999;
                        }
                    }
                }
            }

            .comment {
                padding-top: 30px;

                .commentItem {
                    position: relative;

                    .commentItemContent {
                        width: 100%;
                        border-radius: 5px;
                        box-shadow: 0 0 10px rgba(16, 141, 233, 0.176470588235294);
                        padding: 0 30px 60px;
                        box-sizing: border-box;

                        h3 {
                            font-weight: 700;
                            font-size: 16px;
                            color: #333333;
                            padding: 30px 0 20px;
                            text-align: center;
                        }

                        p {
                            line-height: 25px;
                            font-weight: 400;
                            font-size: 13px;
                            color: #333333;
                        }

                        .explain {
                            width: 100%;
                            height: 58px;
                            background-color: rgba(255, 251, 230, 1);
                            box-sizing: border-box;
                            border: 1px solid rgba(255, 229, 143, 1);
                            border-radius: 4px;
                            color: #999999;
                            line-height: 56px;
                            padding: 0 50px;
                            margin: 30px 0 70px;
                            display: inline-flex;
                            font-size: 13px;

                            i {
                                line-height: 58px;
                                font-size: 22px;
                                padding-right: 10px;
                                color: #faad14;
                            }
                        }

                        .contactsFormClass {
                            /deep/ form {
                                width: 700px;
                                margin: 0 auto;
                            }

                            /deep/ .el-form-item {
                                margin-bottom: 30px;
                            }

                            /deep/ .el-form-item__label {
                                padding-right: 30px;
                            }
                        }

                        .storeInformationFormClass {
                            padding-top: 35px;

                            /deep/ .el-form-item {
                                margin-bottom: 30px;
                            }

                            /deep/ .el-form-item__label {
                                padding-right: 30px;
                            }

                            /deep/ .el-form-item__content {
                                /*width: 750px;*/
                            }

                            .title {
                                font-weight: 700;
                                font-size: 14px;
                                color: #000;
                                padding-bottom: 30px;
                            }

                            .addressSelect {
                                display: flex;

                                .detailAddressClass {
                                    /deep/ .el-input__inner {
                                        width: 380px;
                                    }

                                    /deep/ .el-form-item__content {
                                        margin-left: 0 !important;
                                    }
                                }
                            }

                            .el-radio {
                                margin-right: 10px;
                                min-width: 110px;
                                padding-bottom: 5px;
                            }
                        }

                        .table {
                            width: 880px;
                            margin: 0 auto;
                            border-left: 1px solid #ddd;
                            border-top: 1px solid #ddd;

                            ul {
                                display: flex;
                                width: 100%;

                                &.header {
                                    background: rgba(0, 153, 153, 0.261);

                                    li {
                                        line-height: 40px;
                                        font-weight: 700;
                                        font-style: normal;
                                        color: rgba(51, 51, 51, 0.71)
                                    }
                                }

                                li {
                                    width: 50%;
                                    text-align: center;
                                    line-height: 50px;
                                    color: #333333;
                                    font-size: 13px;
                                    border-bottom: 1px solid #ddd;
                                    border-right: 1px solid #ddd;

                                    i {
                                        padding-right: 10px;
                                        font-size: 20px;
                                        vertical-align: middle;

                                        &.el-icon-success {
                                            color: #009900
                                        }

                                        &.el-icon-warning {
                                            color: #faad14
                                        }
                                        &.el-icon-error{
                                            color: #ff0000;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .commentItemButtonGroup {
                        width: 100%;
                        text-align: center;
                        padding-top: 30px;

                        .conventionButton {
                            width: 111px;
                            height: 33px;
                            background-color: #009999;
                            border: none;
                            border-radius: 15px;
                            font-weight: 400;
                            color: #FFFFFF;
                            padding: 0;
                            text-align: center;
                            line-height: 33px;

                            &:hover {
                                background-color: #009999;
                            }
                        }

                        .Staging {
                            padding: 0 0 0 15px;
                            line-height: 33px;
                            color: #009999;

                            &:hover {
                                color: #009999;
                            }
                        }

                        .backButton {
                            width: 111px;
                            height: 33px;
                            background-color: #fff;
                            border: 1px solid #009999;
                            border-radius: 15px;
                            font-weight: 400;
                            color: #009999;
                            padding: 0;
                            text-align: center;
                            line-height: 33px;

                            &:hover {
                                background-color: #009999;
                                color: #fff;
                            }
                        }
                    }
                }
            }

            .storeAddress {
                /deep/ .el-form-item__content {
                    margin-left: 0 !important;
                }
            }
        }

        /deep/ .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/enter.vue